import Combobox from "discourse/select-kit/components/combo-box";
import FormFieldBase from "./base";
import FormFieldWireFrame from "./wire-frame";

export default class FormFieldComboBox extends FormFieldBase {
  get options() {
    return this.args.options || {};
  }

  get nameProperty() {
    // we need to provide a default value for nameProperty because select-kit will not consider
    // the defaultValue simply because we're passing the argument. Doesn't matter if it's undefined
    if (this.args.nameProperty === undefined) {
      return "name";
    }

    return this.args.nameProperty;
  }

  get valueProperty() {
    // we need to provide a default value for valueProperty because select-kit will not consider
    // the defaultValue simply because we're passing the argument. Doesn't matter if it's undefined
    if (this.args.valueProperty === undefined) {
      return "id";
    }

    return this.args.valueProperty;
  }

  <template>
    <FormFieldWireFrame
      @fieldName={{this.fieldName}}
      @title={{this.title}}
      @description={{this.description}}
      @required={{@required}}
      @validation={{@validation}}
    >
      <Combobox
        class="circles-form-{{@name}}"
        ...attributes
        name={{this.fieldName}}
        @nameProperty={{this.nameProperty}}
        @valueProperty={{this.valueProperty}}
        @value={{@value}}
        @none={{@noneI18n}}
        @content={{@content}}
        @onChange={{@onChange}}
        @options={{this.options}}
      />
      {{yield}}
    </FormFieldWireFrame>
  </template>
}
